import React, { useState } from 'react';

const RadioButtons = ({ setIsCheque }) => {
    const [formValues, setFormValues] = useState({});

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormValues({ [name]: value });
    };
    console.log(formValues);
    return (
        <>
            <div className='float-left mr-4 pt-1' onClick={() => setIsCheque(false)}>
                <input type="radio" id='cash' value='cash' name='radio' className='cursor-pointer' onChange={handleChange} required />
                <label htmlFor="cash" className='text-gray-800 font-semibold text-sm ml-1 cursor-pointer ' >Cash</label>
            </div>
            <div className='float-left mr-4 pt-1' onClick={() => setIsCheque(true)}>
                <input type="radio" id='cheque' value='cheque' name='radio' className='cursor-pointer' onChange={handleChange} required />
                <label htmlFor="cheque" className='text-gray-800 font-semibold text-sm ml-1 cursor-pointer ' >Cheque</label>
            </div>
            <div className='float-left mr-4 pt-1' onClick={() => setIsCheque(false)}>
                <input type="radio" id='dcard' value='dcard' name='radio' className='cursor-pointer' onChange={handleChange} required />
                <label htmlFor="dcard" className='text-gray-800 font-semibold text-sm ml-1 cursor-pointer ' >Debit-Card</label>
            </div>
            <div className='float-left mr-4 pt-1' onClick={() => setIsCheque(false)}>
                <input type="radio" id='ccard' value='ccard' name='radio' className='cursor-pointer' onChange={handleChange} required />
                <label htmlFor="ccard" className='text-gray-800 font-semibold text-sm ml-1 cursor-pointer '>Credit-Card</label>
            </div>
            <div className='pt-1' onClick={() => setIsCheque(false)}>
                <input type="radio" id='online' value='online' name='radio' className='cursor-pointer' onChange={handleChange} required />
                <label htmlFor="online" className='text-gray-800 font-semibold text-sm ml-1 cursor-pointer'>Online</label>
            </div>
        </>
    )
}

export default RadioButtons;